export default {"src":"/_next/static/media/starIcon.93201bf6.svg","height":140,"width":140};